// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__QZnf9","alert":"SettungsInbox_alert__31JFB"};